import { buttonVariants } from '@/shared/components/ui/button';
import { cn } from '@/util/cn';
import { Link } from '@tanstack/react-router';
import { HistoryIcon, SearchIcon } from 'lucide-react';

const ChargeCenterRouteButtons = () => {
  return (
    <div className="$tw-flex $tw-w-full md:$tw-justify-end">
      <div className="cc-views-buttons $tw-flex $tw-w-full $tw-flex-col $tw-gap-2 md:$tw-w-fit md:$tw-flex-row md:$tw-items-center">
        <Link
          to="/charge-center/assets-transactions"
          className={cn(
            buttonVariants({
              variant: 'secondary',
              className:
                '$tw-inline-flex $tw-w-full $tw-items-center $tw-justify-center $tw-gap-2 md:$tw-w-fit',
            }),
            'hover:$tw-text-foreground hover:$tw-no-underline'
          )}
        >
          <div>
            <HistoryIcon className="$tw-size-4" />
          </div>
          Registro de transacciones
        </Link>
        <Link
          to="/charge-center/grid-connections"
          className={cn(
            buttonVariants({
              variant: 'secondary',
              className:
                '$tw-inline-flex $tw-w-full $tw-items-center $tw-justify-center $tw-gap-2 md:$tw-w-fit',
            }),
            'hover:$tw-text-foreground hover:$tw-no-underline'
          )}
        >
          <div>
            <SearchIcon className="$tw-size-4" />
          </div>
          Ver cargadores de todos los empalmes
        </Link>
      </div>
    </div>
  );
};

export default ChargeCenterRouteButtons;
